import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const rightsFaqs = [
    {
      question: "Right to Safety",
      answer:
        "You have the right to be protected against goods and services that are hazardous to your health or life — whether physically, mentally, or otherwise.",
    },
    {
      question: "Right to Information",
      answer:
        "You have the right to complete and accurate information about the quality, quantity, potency, purity, price, and standard of goods or services. No false or misleading claims should be made by sellers or manufacturers.",
    },
    {
      question: "Right to Choose",
      answer:
        "You have the freedom to choose from a variety of products and services at competitive prices. No one can force you to buy a particular brand or product — monopolistic and restrictive trade practices are unlawful.",
    },
    {
      question: "Right to be Heard",
      answer:
        "If you are dissatisfied with a product or service, you have the right to file a complaint and be heard. Authorities are required to address your grievance within a reasonable time frame.",
    },
    {
      question: "Right to Seek Redressal",
      answer:
        "You have the right to seek compensation, replacement, or refund if the product or service is defective or unsatisfactory. The Consumer Protection Act provides a three-tier redressal mechanism — at the District, State, and National levels.",
    },
    {
      question: "Right to Consumer Education",
      answer:
        "You have the right to be informed and educated about your rights and responsibilities. Awareness is the first step toward empowerment — an aware consumer is a protected consumer!",
    },
  ];

  const responsibilitiesFaqs = [
    {
      question: "Be Aware",
      answer:
        "Stay informed about your rights and the relevant laws protecting consumers. Awareness is your first line of defense against exploitation.",
    },
    {
      question: "Be Cautious and Informed",
      answer:
        "Before purchasing, check product details such as quality, quantity, price, expiry date, and usage instructions. Always demand bills or receipts for your purchases.",
    },
    {
      question: "Check for Quality Standards",
      answer:
        "Buy only those goods or services that carry standard quality marks like ISI, Agmark, FSSAI, BIS, or other relevant certifications.",
    },
    {
      question: "Do Not Be Misled by Advertisements",
      answer:
        "Evaluate claims made in advertisements carefully. Avoid falling prey to exaggerated or misleading promotions.",
    },
    {
      question: "Insist on a Cash Memo or Invoice",
      answer:
        "Always obtain a valid proof of purchase. This serves as essential evidence in case of future complaints or disputes.",
    },
    {
      question: "Use Products and Services as Directed",
      answer:
        "Follow safety and usage instructions properly to avoid harm and ensure fair use of goods or services.",
    },
    {
      question: "Lodge Genuine Complaints",
      answer:
        "If you face unfair trade practices, file your complaint responsibly with proper facts and evidence. False or frivolous complaints should be avoided.",
    },
    {
      question: "Promote Consumer Awareness",
      answer:
        "Encourage others to be informed consumers. An aware society strengthens consumer protection for all.",
    },
  ];

  const behaviorFaqs = [
    {
      question: "What is Consumer Interest?",
      answer:
        "Every customer shows inclination towards particular products and services. Consumer interest is nothing but willingness of consumers to purchase products and services as per their taste, need and of course pocket.\n\nExample: Avinash and Akhil went to the nearby shopping mall to buy dresses for themselves. The store manager showed them the best dresses available with him. Avinash immediately purchased two dresses but Akhil returned home empty handed. The dresses were little too expensive for Santoshi More and she preferred simple and subtle designs as compared to designer wears available at the store.\n\nIn the above example Avinash and Akhil had similar requirements but there was a huge difference in their taste, mind set and ability to spend.",
    },
    {
      question: "What is Consumer Behavior?",
      answer:
        "Consumer Behavior is a branch which deals with the various stages a consumer goes through before purchasing products or services for his end use.\n\nWhy do you think an individual buys a product?\n• Need\n• Social Status\n• Gifting Purpose\n\nWhy do you think an individual does not buy a product?\n• No requirement\n• Income/Budget/Financial constraints\n• Taste",
    },
    {
      question: "When do consumers purchase products?",
      answer:
        "• Festive season\n• Birthday\n• Anniversary\n• Marriage or other special occasions\n\nIn fact there are several factors which influence buying decision of a consumer ranging from psychological, social, economic and so on. During Dasehra / Deepawali, the buying tendencies of consumers increase as compared to other months. In the same way during Valentines week, individuals are often seen purchasing gifts for their partners. Fluctuations in the financial markets and recession decrease the buying capacity of individuals.",
    },
    {
      question: "Factors Influencing Consumer Decisions",
      answer:
        "Perception also plays an important role in influencing the buying decision of consumers. Buying decisions of consumers also depend on the following factors:\n• Messages, advertisements, promotional materials, a consumer goes through also called selective exposure.\n• Not all promotional materials and advertisements excite a consumer. A consumer does not pay attention to everything he sees. He is interested in only what he wants to see. Such behavior is called selective attention.\n• Consumer interpretation refers to how an individual perceives a particular message.\n• A consumer would certainly buy something which appeals him the most. He would remember the most relevant and meaningful message also called as selective retention. He would obviously not remember something which has nothing to do with his need.",
    },
  ];

  const disputesFaqs = [
    {
      question: "Consumer Disputes in India",
      answer:
        "A consumer dispute means a situation where the person or company against whom a complaint has been made denies or disputes the allegations raised by the consumer.\n\nBefore reviewing the consumer redressal forums, it is important to understand the wide range of issues for which a consumer can seek justice.",
    },
    {
      question: "Common Types of Consumer Disputes",
      answer:
        "Goods and Services:\n• Defective or substandard products and appliances\n• Misleading advertisements or false claims about goods or services\n• Sale of expired, adulterated, or unsafe food items\n• Non-delivery or delay in delivery of purchased goods\n• Online shopping / E-commerce frauds and fake listings\n• Sale of duplicate or counterfeit products\n\nUtilities and Services:\n• Electricity consumption and inflated billing disputes\n• Water supply, gas connection, and pipeline issues\n• Telecommunication and internet service problems — poor connectivity, hidden charges, or wrongful disconnection\n• Cable TV / DTH subscription issues\n\nHealth and Insurance:\n• Medical negligence or deficiency in healthcare services\n• Disputes with hospitals, clinics, nursing homes, and diagnostic centers\n• Health, life, vehicle, and property insurance claim delays or rejections\n• Pharmacy and medicine-related grievances\n\nHousing and Real Estate:\n• Builders, developers, and housing projects — delay in possession, poor construction, or non-refund of advance\n• Housing societies or maintenance disputes\n\nFinancial and Banking Services:\n• Banks and financial institutions — wrongful deductions, failed transactions, or excessive service charges\n• Credit card and loan disputes\n• Investment frauds, chit funds, or unauthorized financial advice\n• Microfinance and NBFC-related complaints\n\nTransport and Travel:\n• Airlines, railways, bus, and cab services — cancellations, overcharging, or loss of baggage\n• Travel agencies and tour operators — misleading packages or denial of promised services\n• Auto companies and dealers — manufacturing defects, poor service, or warranty violations\n\nHospitality and Food:\n• Hotels, restaurants, and catering services — overcharging, food poisoning, poor hygiene\n• Online food delivery platforms — wrong, delayed, or unsafe food delivery\n\nEducation and Institutions:\n• Schools, colleges, and coaching centres — unjustified fees, false promises, or poor quality of education\n• Skill training and certification agencies — failure to deliver promised outcomes\n\nRepairs and Maintenance:\n• Service stations and repair centres — improper repair, replacement issues, or overcharging\n• Electronic service providers — refusal of warranty or substandard after-sales support\n\nDigital and Online Services:\n• E-wallet and UPI payment failures\n• Subscription-based OTT or app services — automatic renewals or billing disputes\n• Data privacy breaches or misuse of personal information\n• Cyber frauds or unauthorized transactions\n\nOthers:\n• Courier and postal services — loss, delay, or damage of parcels\n• Event management and wedding planning services\n• Gym, spa, or club memberships — non-delivery of services after payment\n• Government and semi-government services where fees are paid but duties are not properly discharged\n\nNote: The above list is illustrative, not exhaustive. Any act that involves deficiency, defect, unfair trade practice, overcharging, or denial of rightful service can become a consumer dispute. Public authorities and organizations like the Consumer Rights Council (CRC) play a vital role in helping consumers raise such issues and seek justice through the proper legal forums.",
    },
  ];

  const redressalFaqs = [
    {
      question: "Redressal Commissions in India",
      answer:
        "Even after being careful and informed, consumers may sometimes face unfair trade practices, defective goods, deficient services, or overcharging. When such issues arise, they are called Consumer Disputes.\n\nTo resolve these disputes, the Consumer Protection Act, 2019 has established a three-tier quasi-judicial redressal mechanism known as the Consumer Disputes Redressal Commissions (CDRCs) at the District, State, and National levels.\n\n1. District Consumer Disputes Redressal Commission (DCDRC)\n• Jurisdiction: Complaints where the value of goods/services paid as consideration does not exceed ₹50 lakh.\n• Headed by: A President and at least two Members.\n• Function: Handles complaints related to unfair trade practices, defective products, and deficient services within the district.\n\n2. State Consumer Disputes Redressal Commission (SCDRC)\n• Jurisdiction: Complaints where the value exceeds ₹50 lakh but does not exceed ₹2 crore, and appeals against orders of the District Commission.\n• Headed by: A President (usually a former High Court Judge) and members.\n• Function: Acts as an appellate body for District Commission decisions and handles higher-value complaints.\n\n3. National Consumer Disputes Redressal Commission (NCDRC)\n• Jurisdiction: Complaints where the value of goods/services exceeds ₹2 crore, and appeals against orders of State Commissions.\n• Headed by: A President (usually a former Supreme Court Judge) and members.\n• Function: Highest authority under the Act, supervising and guiding lower commissions.",
    },
  ];

  const renderFaqSection = (title, faqsArray) => {
    // Filter FAQs based on search query
    const filteredFaqs = faqsArray.filter(
      (faq) =>
        faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <>
        <h3 className="text-2xl font-semibold text-primary mt-10">{title}</h3>
        <div className="space-y-4 mt-3">
          {filteredFaqs.length > 0 ? (
            filteredFaqs.map((faq, index) => (
              <div
                key={index}
                className="border rounded-2xl border-gray-200 shadow-sm bg-white"
              >
                <button
                  className="flex justify-between items-center w-full px-5 py-4 text-left font-medium text-gray-800 hover:bg-gray-100"
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  {faq.question}
                  <FaChevronDown
                    className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4 text-gray-600 text-[15px] leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="text-gray-500 mt-2">
              No results found for "{searchQuery}"
            </p>
          )}
        </div>
      </>
    );
  };

 return (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-indigo-50">

    {/* ---------- HERO ---------- */}
    <section className="max-w-5xl mx-auto px-6 pt-20 pb-12 text-center">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary-200 pb-4">
        Consumer Rights & Protection
      </h1>
      <p className="mt-4 text-slate-600 max-w-3xl mx-auto leading-relaxed">
        Have you ever realized that you are a consumer and what makes you a consumer in the eyes of the law?
        Let’s unpack the definition and explore your rights under the Consumer Protection Act (CPA) 2019.
      </p>

      {/* Glass-morphism search bar */}
      <div className="mt-8 max-w-2xl mx-auto">
        <div className="relative">
          <input
            type="text"
            placeholder="Search your question..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-3 rounded-2xl border border-white/30
                       bg-white/60 backdrop-blur-md shadow-lg
                       focus:outline-none focus:ring-2 focus:ring-indigo-400
                       text-slate-800 placeholder-slate-500"
          />
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </span>
        </div>
      </div>
    </section>

    {/* ---------- ARE YOU A CONSUMER? ---------- */}
    <section className="max-w-5xl mx-auto px-6 mb-10">
      <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg ring-1 ring-black/5">
        <h3 className="text-xl font-bold text-slate-800 mb-2">Are You a Consumer?</h3>
        <p className="text-slate-600 leading-relaxed">
          Then You Must Know Your Rights & Responsibilities! A consumer is any person who buys goods or
          avails services for a consideration. As a consumer, you have certain rights to ensure that you
          are treated fairly and protected from exploitation.
        </p>
      </div>
    </section>

    {/* ---------- FAQ ACCORDIONS ---------- */}
    <section className="max-w-5xl mx-auto px-6 pb-20 space-y-12">
      {renderFaqSection("Consumer Rights", rightsFaqs)}
      {renderFaqSection("Responsibilities of a Consumer", responsibilitiesFaqs)}
      {renderFaqSection("Consumer Behavior", behaviorFaqs)}
      {renderFaqSection("Consumer Disputes & Redressal Commissions in India", disputesFaqs)}
      {renderFaqSection("Redressal Commissions in India", redressalFaqs)}
    </section>

      {/* How to File a Complaint Section */}
      <div className="max-w-5xl mx-auto py-16 px-6 bg-white rounded-2xl shadow-md mt-12">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">
          How to File a Complaint
        </h2>

        <p>A consumer can file a complaint:</p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>
            Online: Through the E-Daakhil Portal (
            <a
              href="https://www.edaakhil.nic.in"
              className="text-blue-600 underline"
            >
              www.edaakhil.nic.in
            </a>
            )
          </li>
          <li>
            Offline: By submitting a written complaint to the appropriate
            Consumer Commission
          </li>
          <li>No lawyer is mandatory — consumers can represent themselves</li>
        </ul>

        <p>Complaints can be filed for:</p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>Defective goods</li>
          <li>Deficient services</li>
          <li>Unfair or restrictive trade practices</li>
          <li>Overcharging or misleading advertisements</li>
          <li>Sale of hazardous goods</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-2">
          Filing a Consumer Case through CRC
        </h3>
        <p>
          If you are unable to personally appear or handle your consumer
          dispute, you can authorize the Consumer Rights Council (CRC) to file
          and pursue the case on your behalf.
        </p>

        <h4 className="font-semibold mt-4">How It Works</h4>
        <ol className="list-decimal list-inside text-gray-700 mb-4">
          <li>
            <strong>Authorization Letter:</strong> The consumer provides a
            written authorization letter to CRC, permitting the Council to act
            and represent them before the appropriate Consumer Redressal
            Commission.
          </li>
          <li>
            <strong>Supporting Documents:</strong> Along with the authorization
            letter, the consumer must provide:
            <ul className="list-disc list-inside ml-6 mt-2">
              <li>Proof of purchase (invoice/bill/cash memo)</li>
              <li>
                Copies of correspondence or complaint to the opposite party
              </li>
              <li>Product or service details, warranty cards, etc.</li>
              <li>Identity proof (Aadhaar/PAN)</li>
            </ul>
          </li>
          <li>
            <strong>Filing the Complaint:</strong> CRC will draft, prepare, and
            file the complaint before the competent District, State, or National
            Consumer Commission, depending on the value of the claim.
          </li>
          <li>
            <strong>Representation:</strong> CRC’s authorized legal
            representatives or consumer activists will appear and pursue the
            matter until final disposal, ensuring the consumer’s interests are
            protected.
          </li>
          <li>
            <strong>Transparency:</strong> The consumer remains informed about
            every stage of the case — from filing to hearing and final order.
          </li>
        </ol>

        <h4 className="font-semibold mt-4">Why File Through CRC?</h4>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Expert legal drafting and representation</li>
          <li>Faster than filing through E-Daakhil portal or in person</li>
          <li>Guidance on documents and evidence</li>
          <li>Support till execution of the final order</li>
        </ul>

        <h4 className="font-semibold mt-4">Relief Available</h4>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Replacement or repair of defective goods</li>
          <li>Refund of price paid</li>
          <li>Compensation for loss or injury</li>
          <li>Discontinuation of unfair practices</li>
          <li>Withdrawal of misleading advertisements</li>
        </ul>

        <h4 className="font-semibold mt-4">Key Contact Details</h4>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>
            <strong>National Consumer Helpline (NCH)</strong>
            Toll-Free Numbers: 1800-11-4000, 1915 SMS Callback Request:
            8800001915 Email:{" "}
            <a href="mailto:nch-ca@gov.in" className="text-blue-600 underline">
              nch-ca@gov.in
            </a>
            Website:{" "}
            <a
              href="https://www.consumerhelpline.gov.in"
              className="text-blue-600 underline"
            >
              consumerhelpline.gov.in
            </a>
          </li>
          <li>
            <strong>Indian Cybercrime Helpline</strong>
            Toll-Free Number: 1930 Website:{" "}
            <a
              href="https://www.cybercrime.gov.in"
              className="text-blue-600 underline"
            >
              cybercrime.gov.in
            </a>
          </li>
          <li>
            <strong>E-Daakhil Portal (Consumer Complaints Filing)</strong>
            Website:{" "}
            <a
              href="https://www.edaakhil.nic.in"
              className="text-blue-600 underline"
            >
              edaakhil.nic.in
            </a>
          </li>
          <li>
            <strong>Online Portal – PMO Grievance Redressal</strong>
            Website:{" "}
            <a
              href="https://www.pmindia.gov.in/en/online-complaints/"
              className="text-blue-600 underline"
            >
              pmindia.gov.in
            </a>
          </li>
          <li>
            <strong>National Consumer Helpline (CRC)</strong>
            WhatsApp: 9963633653 Landline: 0891-2533653 Email:{" "}
            <a
              href="mailto:office@crcbharat.com"
              className="text-blue-600 underline"
            >
              office@crcbharat.com
            </a>
            Website:{" "}
            <a
              href="http://www.crcbharat.com"
              className="text-blue-600 underline"
            >
              www.crcbharat.com
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FAQ;
